import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import { CustomRadioGroupInput } from "../components/custom_radio_group_input";

import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateVerificacaoChecklistItensColumnsDefinition
 */

type Props = {
  statusChecklist: number | null;
  lockChecklistItens: boolean | undefined;
  onActionOcorrencia: (idOcorrencia: number | null, idVerificacaoCliente: number | null, openState: boolean) => void;
  onActionInspecao1Change: (idVerificacaoCliente: number, value: string | number | null) => void;
  onActionInspecao2Change: (idVerificacaoCliente: number, value: string | number | null) => void;
  onActionLimpar: (idVerificacaoCliente: number) => void;
};

export const GenerateVerificacaoChecklistItensColumnsDefinition = ({
  statusChecklist,
  lockChecklistItens,
  onActionOcorrencia,
  onActionInspecao1Change,
  onActionInspecao2Change,
  onActionLimpar,
}: Props): GridColDef[] => {

  const inspecao1Options = [
    {
      id: "N",
      label: "NA",
      style: {
        backgroundColor: "#89c4f4",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "A",
      label: "A",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "R",
      label: "R",
      style: {
        backgroundColor: "#f8cb00",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "X",
      label: "X",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  const inspecao2Options = [
    {
      id: "A",
      label: "RA",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "X",
      label: "X",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  return [
    {
      field: "novaOcorrencia",
      filterable: false,
      headerName: "",
      minWidth: 160,
      maxWidth: 160,
      sortable: false,
      headerClassName: "funcionarios-header",
      valueGetter: (_, row) => row["idVerificacaoCliente"],
      renderCell: ({ value, row }) => {
        if (value === null || value === undefined) return null;
        return (
          <div className="w-[9rem] h-full flex items-center">
            <PrimaryButton
              size="small"
              buttonColor="red"
              onClick={() => onActionOcorrencia(null, value, true)}
              startIcon={<DynamicIcon nameIcon="Add" size={15} className="text-white" />}
            >
              Nova ocorrencia
            </PrimaryButton>
          </div>
        );
      },
    },
    {
      field: "inspecao1",
      filterable: false,
      headerName: "1ª Inspeção",
      minWidth: 280,
      maxWidth: 280,
      sortable: false,
      valueGetter: (_, row) => ({ idVerificacaoCliente: row["idVerificacaoCliente"], inspecao1: row["inspecao1"] }),
      renderCell: ({ value, row }) => {
        if (value.idVerificacaoCliente === null || value.idVerificacaoCliente === undefined) return null;
        return (
          <div className="w-full h-full flex items-center">
            <CustomRadioGroupInput
              name="inspecao1"
              options={inspecao1Options}
              value={value.inspecao1}
              readOnly={lockChecklistItens || statusChecklist === 1}
              onValueChange={(v) => onActionInspecao1Change(value.idVerificacaoCliente, v)}
            />
          </div>
        );
      },
    },
    {
      field: "inspecao2",
      filterable: false,
      headerName: "2ª Inspeção",
      minWidth: 155,
      maxWidth: 155,
      sortable: false,
      valueGetter: (_, row) => ({
        idVerificacaoCliente: row["idVerificacaoCliente"],
        inspecao1: row["inspecao1"],
        inspecao2: row["inspecao2"],
      }),
      renderCell: ({ value, row }) => {
        if (value.idVerificacaoCliente === null || value.idVerificacaoCliente === undefined) return null;
        return (
          <div className="w-full h-full flex items-center">
            <CustomRadioGroupInput
              name="inspecao2"
              options={inspecao2Options}
              disabled={value.inspecao1 !== "R"}
              value={value.inspecao2}
              readOnly={lockChecklistItens || statusChecklist === 1}
              onValueChange={(v) => onActionInspecao2Change(value.idVerificacaoCliente, v)}
            />
          </div>
        );
      },
    },
    {
      field: "limpar",
      sortable: false,
      filterable: false,
      headerName: "Limpar",
      width: 65,
      maxWidth: 65,
      valueGetter: (_, row) => row["idVerificacaoCliente"] as number,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return null;
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => {
                if (!lockChecklistItens && statusChecklist !== 1) onActionLimpar(params.value);
              }}>
              <DynamicIcon nameIcon="CleaningServices" size={25} className="text-[#f8cb00]" />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
